import { Injectable } from '@angular/core';

type InvestigatorForecastSettings = Record<string, Record<string, Settings>>;

interface Settings {
  lastSaved: boolean;
  vendorId: string;
}

@Injectable({ providedIn: 'root' })
export class InvestigatorForecastLsService {
  private localStorageKey = 'investigatorForecast';

  private getLastSavedSettings(trialId: string): Settings | undefined {
    const list = this.getListSelections();

    return Object.values(list[trialId] || {}).find(({ lastSaved }) => !!lastSaved);
  }

  getLastSavedVendorByTrial(trialId: string) {
    const settings = this.getLastSavedSettings(trialId);

    return settings?.vendorId || '';
  }

  private getListSelections(): InvestigatorForecastSettings {
    return JSON.parse(localStorage.getItem(this.localStorageKey) || '{}');
  }

  saveSettings(trialId: string, vendorId: string) {
    const list = this.getListSelections();

    const trialSettings = list[trialId] || {};

    // reset lastSaved flag for prev settings
    let updatedList = Object.entries(trialSettings).reduce<InvestigatorForecastSettings>(
      (accum, [vendorKey, settings]) => {
        return {
          ...accum,
          [trialId]: {
            ...accum[trialId],
            [vendorKey]: {
              ...settings,
              lastSaved: false,
            },
          },
        };
      },
      {}
    );

    const settings = {
      lastSaved: true,
      vendorId,
    };

    if (updatedList[trialId]) {
      updatedList[trialId][vendorId] = settings;
    } else {
      updatedList = {
        ...list,
        [trialId]: {
          [vendorId]: settings,
        },
      };
    }

    localStorage.setItem(this.localStorageKey, JSON.stringify(updatedList));
  }
}
